import type {
  OrderItem,
  SubmittedRequestItem,
} from '../../graphql/query/getOrder';
import type { PackagingOption } from '../../graphql/query/getDelivery';
import type { SubmitStatus } from '../../graphql/mutation/submit';
import type { SubmittedItem } from './types';
import { languageData } from '../Language/Language';

export const getSubmittedItems = ({
  requestItems,
  orderItems,
}: {
  orderItems?: OrderItem[];
  requestItems: Pick<SubmittedRequestItem, 'id' | 'quantity'>[];
}) =>
  requestItems?.reduce<SubmittedItem[]>((acc, item) => {
    const orderItem = orderItems?.find((i) => i.id === item.id);
    if (!orderItem) return acc;
    acc.push({
      ...orderItem,
      quantity: item.quantity ?? 1,
    });
    return acc;
  }, []) ?? [];

export const getAvailableInstructionCount = ({
  status,
  type,
  packaging,
}: {
  type?: string;
  packaging?: PackagingOption | null;
  status: SubmitStatus;
}): number => {
  const baseKeys: string[] = getBaseKeys({ status, type, packaging });
  const languageKeys = Object.keys(languageData());

  // Check each base key to find the highest instruction number
  let maxInstructionNumber = 0;

  for (const baseKey of baseKeys) {
    // Look for title keys in the language data
    const titlePattern = new RegExp(
      `^${baseKey.replace(/\./g, '\\.')}\\.title\\.(\\d+)(?:\\.(singular|plural))?$`,
    );

    for (const langKey of languageKeys) {
      const match = langKey.match(titlePattern);
      if (match && match[1]) {
        const instructionNumber = parseInt(match[1], 10);
        maxInstructionNumber = Math.max(
          maxInstructionNumber,
          instructionNumber,
        );
      }
    }
  }

  return maxInstructionNumber;
};

export const getBaseKeys = ({
  status,
  type,
  packaging,
}: {
  type?: string;
  packaging?: PackagingOption | null;
  status: SubmitStatus;
}) => {
  return [
    `Global.confirmation.${status}.instructions.${type}.${packaging}`,
    `Global.confirmation.instructions.${type}.${packaging}`,
    `Global.confirmation.instructions`,
  ];
};
